var React = require('react');

function Edit2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_107006","data-name":"Path 107006","d":"M0,0H5.237v10.4L2.619,13.189,0,10.406Z","transform":"translate(10.631 3.414) rotate(45)","fill":"none","stroke":"#b1b1b1","strokeWidth":"1.5","key":0}),React.createElement("line",{"id":"Line_24359","data-name":"Line 24359","x2":"6","transform":"translate(12.671 0.707) rotate(45)","fill":"none","stroke":"#b1b1b1","strokeWidth":"2","key":1})]);
}

Edit2.defaultProps = {"width":"17.621","height":"17.748","viewBox":"0 0 17.621 17.748"};

module.exports = Edit2;

Edit2.default = Edit2;
